import React from "react";
import PageWrapper from "../../../../PageWrapper";
import PrimaryButton from "../../../../SFUCentralThemedComponents/PrimaryButton";

export default function ConfirmationPage({ savePage, goToPage }) {
  return (
    <PageWrapper>
      <>
        <div className="p-grid">
          <div className="p-col-12">
            <p style={{ marginTop: "30px" }}>
              {" "}
              We appreciate your interest in the Uggla Family Scholarship and
              your time in completing your application.{" "}
            </p>
            <p>
              {" "}
              Your application to the SFU Uggla Family Scholarship has been
              submitted.
            </p>
            <p>
              {" "}
              For information on next steps please check your email for a
              message from us.
            </p>
          </div>
        </div>
        {process.env.NODE_ENV === "development" ? (
          <>
            <div className="p-grid button-navigation-container">
              <div className="p-col-12">
                <PrimaryButton
                  onClick={() => {
                    savePage({ status: "Pending" });
                    goToPage(1);
                  }}
                >
                  Unsubmit App
                </PrimaryButton>
              </div>
            </div>
          </>
        ) : (
          ""
        )}
      </>
    </PageWrapper>
  );
}
